import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperMissionPage } from './shopper-mission';

@NgModule({
  declarations: [
    ShopperMissionPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperMissionPage),
    TranslateModule.forChild()
  ],
})
export class ShopperMissionPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-mission/shopper-mission.module.ts